// extracted by mini-css-extract-plugin
export var container = "components-__InfoPanel-module___container";
export var content = "components-__InfoPanel-module___content";
export var icon = "components-__InfoPanel-module___icon";